import React from 'react'
import { Table, Tag, Space, Skeleton } from 'antd'
import { RobotOutlined } from '@ant-design/icons'
import Section from '../section/Section';
import useSWR from 'swr';
import ApiManager from '../../../business/services/ApiManager';
import { useSelector } from 'react-redux';
import { RootState } from '../../../model/rootReducer';

const SubscriptionList = () => {
    const { data, error } = useSWR(
        'Subscriptions', (_key) =>
        ApiManager.customers.getSubscriptions()
    )
    const bots = useSelector((state: RootState) => state.bot.bots)
        
    if (error) return <div>failed to load</div>
    if (!data) return <Skeleton active />
    
    const columns = [
        {
            title: 'Bot',
            dataIndex: 'botId',
            key: 'botId',
            render: (botId: React.ReactNode) => (
                <Space size="small">
                    <RobotOutlined /> {bots.find(x => x.id === botId)?.name}
                </Space>
            )
        },
        {
            title: 'Statut',
            dataIndex: 'isActive',
            key: 'bot',
            render: (isActive: boolean) =>
                isActive ? (
                    <Tag color="green">ACTIF</Tag>
                ) : (
                    <Tag color="red">INACTIF</Tag>
                )
        },
        {
            title: 'Type de facturation',
            dataIndex: 'type',
            key: 'type',
            render: (text: React.ReactNode) => "Mensuel"
        }
    ]

    return (
        <Section title="Abonnement" subTitle="Chaque bot déployé est considéré comme un abonnement">
            <Table columns={columns} dataSource={data.data} />
        </Section>
    )
}

export default SubscriptionList
